import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon in React-Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const LocationMarker = ({ position, onPositionChange }) => {
  const [dragging, setDragging] = useState(false);

  const map = useMapEvents({
    click(e) {
      if (!dragging) {
        onPositionChange(e.latlng);
      }
    },
  });

  useEffect(() => {
    if (position) {
      map.flyTo(position, map.getZoom());
    }
  }, [position, map]);

  const eventHandlers = {
    dragstart: () => {
      setDragging(true);
    },
    dragend: (e) => {
      const marker = e.target;
      const newPosition = marker.getLatLng();
      onPositionChange(newPosition);
      setTimeout(() => setDragging(false), 100);
    },
  };

  return position ? (
    <Marker
      position={position}
      draggable={true}
      eventHandlers={eventHandlers}
    />
  ) : null;
};

const MapLocationPicker = ({ latitude, longitude, onLocationSelect, disabled }) => {
  const [position, setPosition] = useState(null);

  // Set initial position from props
  useEffect(() => {
    if (latitude && longitude && latitude !== 0 && longitude !== 0) {
      setPosition({ lat: latitude, lng: longitude });
    } else {
      // Default to Bangkok
      setPosition({ lat: 13.7563, lng: 100.5018 });
    }
  }, [latitude, longitude]);

  const handlePositionChange = (newPosition) => {
    if (!disabled) {
      setPosition(newPosition);
      onLocationSelect(newPosition.lat, newPosition.lng);
    }
  };

  return (
    <div className="map-location-picker">
      <label>
        ตำแหน่งที่ตั้งเครื่อง <span className="required">*</span>
      </label>
      <p className="map-hint">คลิกบนแผนที่หรือลากหมุดเพื่อเลือกตำแหน่งที่ติดตั้งเครื่อง</p>

      <div className="map-container">
        {position && (
          <MapContainer
            center={position}
            zoom={12}
            style={{ height: '400px', width: '100%' }}
            className="leaflet-map"
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <LocationMarker
              position={position}
              onPositionChange={handlePositionChange}
            />
          </MapContainer>
        )}
      </div>

      {position && (
        <div className="coordinates-display">
          <span>
            <strong>ละติจูด:</strong> {position.lat.toFixed(6)}
          </span>
          <span>
            <strong>ลองจิจูด:</strong> {position.lng.toFixed(6)}
          </span>
        </div>
      )}
    </div>
  );
};

export default MapLocationPicker;
